import React, { useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { useAuth } from "@/contexts/AuthContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function Profile() {
  const { user, refresh } = useAuth();
  const [f, setF] = useState({
    name: user.name || "", company_name: user.company_name || "",
    phone: user.phone || "", country: user.country || "", bio: user.bio || "",
  });
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.patch("/me/profile", f);
      toast.success("Profile updated");
      await refresh();
    } catch (e2) {
      toast.error(formatApiErrorDetail(e2.response?.data?.detail));
    } finally { setBusy(false); }
  };
  return (
    <DashboardLayout title="My profile">
      <div className="max-w-3xl">
        <Card className="card-lift">
          <CardHeader>
            <div className="flex items-center justify-between">
              <CardTitle className="font-heading tracking-tight">Account details</CardTitle>
              <Badge variant="outline" className="capitalize" data-testid="profile-status">{user.status}</Badge>
            </div>
          </CardHeader>
          <CardContent>
            <form onSubmit={save} className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="profile-form">
              <div><Label>Email</Label><Input value={user.email} disabled data-testid="profile-email" /></div>
              <div><Label>Role</Label><Input value={user.role} disabled data-testid="profile-role" /></div>
              <div><Label htmlFor="name">Name</Label><Input id="name" data-testid="profile-name" value={f.name} onChange={(e)=>setF({...f,name:e.target.value})}/></div>
              <div><Label htmlFor="company">Company</Label><Input id="company" data-testid="profile-company" value={f.company_name} onChange={(e)=>setF({...f,company_name:e.target.value})}/></div>
              <div><Label htmlFor="country">Country</Label><Input id="country" data-testid="profile-country" value={f.country} onChange={(e)=>setF({...f,country:e.target.value})}/></div>
              <div><Label htmlFor="phone">Phone</Label><Input id="phone" data-testid="profile-phone" value={f.phone} onChange={(e)=>setF({...f,phone:e.target.value})}/></div>
              <div className="md:col-span-2"><Label htmlFor="bio">Short bio</Label><Textarea id="bio" data-testid="profile-bio" rows={3} value={f.bio} onChange={(e)=>setF({...f,bio:e.target.value})}/></div>
              <div className="md:col-span-2"><Button data-testid="profile-save" type="submit" disabled={busy}>{busy ? "Saving…" : "Save changes"}</Button></div>
            </form>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
}
